// extracted by mini-css-extract-plugin
export default {"IntroWapper":"NFCIntro_IntroWapper__BsJkX","title":"NFCIntro_title__S+Og2","emojis":"NFCIntro_emojis__DHrLU"};